const faqs = [
  {
    title: "3ChatClaw 会导致我的社交账号（小红书/抖音/微信）封号吗？",
    content: `这是我们研发的初衷。传统云端工具使用机房 IP，极易触碰大厂风控红线。3ChatClaw 采用 本地部署（Station）+ 真实手机真机接管 模式，使用的是您本地真实的宽带 IP 和物理网络拓扑。
- 拟人化节律： 内置 OpenClaw 模拟真人的随机点击、滑动速度和阅读停留。
- 物理防封： 每一台手机都是真实的物理设备，拥有独立的硬件指纹，彻底免疫针对“模拟器”或“云端 IP”的批量封号。`,
  },
  {
    title: "我是一个实体店老板，不懂代码，能学会使用 3ChatClaw 吗？",
    content: `完全可以。我们摒弃了复杂的技术逻辑，将功能封装成了 “预置实战技能包”。
- 开箱即用： 您只需在 Station 后台像招聘员工一样选择“商机雷达”或“流量截胡”技能，输入您的行业关键词即可启动。
- 零代码操作： 无需编写脚本，只要您会用电脑和手机，就能轻松驾驭您的数字员工兵团。`,
  },
  {
    title: "为什么 3ChatClaw 强调必须接管“手机真机”？",
    content: `因为流量都在 App 里，而大厂 AI 进不去。
- 突破 API 禁区： 很多高价值动作（如私信、看评论、同城打卡）在电脑网页端是做不了的。
- 物理渗透： 只有接管真实手机，AI 才能像真人一样钻进 App 内部执行任务。只要员工手指能点、能划的操作，3ChatClaw 都能自动化执行。`,
  },
  {
    title: "3Chat Credit（算力点）是怎么计费的？",
    content: `充值 Credit 等于给 AI 员工发工资。我们按效果计费：
- 进攻性动作： 如【商机雷达】或【流量截胡】成功发出一出精准破冰私信，扣除 10 Credits。
- 转化性动作： 如【金牌销冠】进行一次单轮 AI 知识库回复，仅扣除 3 Credits。
- 失败不计费： 若因对方设置等原因导致动作未执行，不消耗任何算力点。`,
  },
  {
    title: "如果我有多个平台的店铺（抖店、千牛、拼多多），能同时管理吗？",
    content: `可以。这是 3ChatClaw 的核心卖点之一。
- 多开并发： 3ChatClaw  后台支持同时挂载多个平台的商家版客户端。
- 极速接管： 只要人工客服离开座位，3ChatClaw  会瞬间接管所有平台的咨询。通过“金牌销冠”技能，确保全平台回复时间，拉满店铺服务权重。`,
  },
  {
    title: "3ChatClaw 真的能处理“选什么码”、“发什么快递”这种复杂问题吗？",
    content: `能。传统的 AI 只是“复读机”，但 3Chat Agent 是**“销冠大脑”**。
- 本地知识库： 您可以将店里的尺码表、退换货政策、SKU 资料喂给它。
- 逻辑推理： 遇到“我 160cm 55kg 穿什么合适”时，它会查表计算并给出精准建议，甚至直接发送商品链接进行逼单。`,
  },
  {
    title: "硬件设备有什么要求？我需要专门买台电脑吗？",
    content: `为了保障 24 小时稳定运行，我们建议配置如下：
- 3ChatClaw 部署： 推荐使用 Mac mini (M4 芯片, 16G 内存) 或 Windows 10 以上的 PC。
- 手机端： 支持 Android 系统真机。您可以利用手头的旧手机，通过 USB 连接至 3ChatClaw  即可完成物理接管。`,
  },
  {
    title: "购买 ¥198/月的软件订阅后，还有其他隐形收费吗？",
    content: `价格透明是我们的一贯原则。
- 包含内容： 订阅费包含官方 Skill 授权、ADB 链路打通和每月赠送的基础 4,000 Credits。
- 自主选择： 硬件（如 Mac mini、手机）需商家自备；若赠送算力消耗完，可根据业务量自主增购算力大礼包。`,
  },
  {
    title: "3ChatClaw 和 3Chat.ai 有什么区别？",
    content:
      "它们并不是相互替代的产品，而是“数字员工”的一体两面。如果把您的业务比作一家公司，它们的角色分工如下：3ChatClaw 负责在公域（抖音、小红书）为您“打猎”，把精准线索抓回来；而 3Chat.ai 负责在私域（企微、飞鸽等私信）为您“收网”，完成最终的成交回款。没有 3ChatClaw，线索进不去私域；没有 3Chat.ai，私域运营也只是机械的复读机。两者结合，才是一个完整的“数字销冠”。",
  },
];

export default faqs;
